import isVerifyTokenGuard from "@/guards/verifyTokenGuard";
import verifyTokenGuardWithoutPermission from "@/guards/verifyTokenGuardWithoutPermission";

export default {
    name: 'patient-blood-pressure',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'patient-blood-pressure-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                   
                    {                           
                        transKey: 'breadcrumbs.blood-pressure',
                        isActive: true
                    }
                ]
            }, 
            component: () => import(/* webpackChunkName: "blood-pressure-create" */ '@/modules/patient-profile/blood-pressure/views/Index.vue')
        }
    ]
}